export default "__VITE_PUBLIC_ASSET__7550971a__"